import React, { useCallback, useState, Component } from 'react'

import RemoveCollectionFromPeople from '../../Services/Mutations/RemoveCollectionFromPeople'
import RemoveListFromPeople from '../../Services/Mutations/RemoveListFromPeople'
import UpdateSectionDetails from '../../Services/Mutations/UpdateSectionDetails'
import RemoveSection from '../../Services/Mutations/RemoveSection'
import UpdateSection from '../../Services/Mutations/UpdateSection'
import { Button, Modal } from 'react-bootstrap'
import { divide } from 'lodash-es'
const styles = {
  otherLabelStyle: { bottom: 0, right: '5px', position: 'absolute', cursor: 'default' },
}
class DraggableTemplateSections extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalVisible: false,
      itemTodelete: {},
      label_Te: '',
      label_En: '',
      label_Hi: '',
      itemToEdit: {},
      showModal: false,
      showOtherLables: false,
      sectionDetails: props.sectionDetails,
      remeasure: '',
      boxes: [
        {
          id: 'Box-1',
          color: 'red',
          order: 1,
        },
        {
          id: 'Box-2',
          color: 'green',
          order: 2,
        },
        {
          id: 'Box-3',
          color: 'blue',
          order: 3,
        },
      ],
      dragId: '',
    }
    this.myCallback = this.renderItem.bind(this)
  }
  componentDidUpdate(prevProps) {
    if (prevProps.sectionDetails.length != this.props.sectionDetails.length) {
      this.setState({
        sectionDetails: this.props.sectionDetails,
      })
    }
  }
  deleteSectionFromPage = async () => {
    const { itemTodelete } = this.state
    this.setState({ modalVisible: false })
    this.props.removeSection(itemTodelete)

    // const input = {
    //   PK: itemTodelete.PK,
    //   SK: itemTodelete.SK,
    // }
    //for page and people delete use remove section
    //for collection and list use seperate services

    // if (itemTodelete.GSIRecordType == 'peopleCollections') {
    //   const data = await RemoveCollectionFromPeople(input)
    //   if (data.statusCode == 'A273') {
    //     this.setState({ modalVisible: false })
    //     this.props.removeSection(itemTodelete)
    //   }
    // } else if (itemTodelete.GSIRecordType == 'peopleLists') {
    //   const data = await RemoveListFromPeople(input)

    //   if (data.statusCode == 'A269') {
    //     this.setState({ modalVisible: false })
    //     this.props.removeSection(itemTodelete)
    //   }
    // } else if (itemTodelete.GSIRecordType == 'pageSectionPeople') {
    //   const data = await RemoveSection(input)

    //   if (data.statusCode == 'A293') {
    //     this.setState({ modalVisible: false })
    //     this.props.removeSection(itemTodelete)
    //   }
    // } else if (itemTodelete.GSIRecordType == 'peopleSectionPeople') {
    //   const data = await RemoveSection(input)

    //   if (data.statusCode == 'A293') {
    //     this.setState({ modalVisible: false })
    //     this.props.removeSection(itemTodelete)
    //   }
    // }
  }
  handleEnSectionLabel = (e) => {
    const sectionLabel = e.target.value
    this.setState({ label_En: sectionLabel })
  }
  handleTeSectionLabel = (e) => {
    const sectionLabel = e.target.value

    this.setState({ label_Te: sectionLabel })
  }
  handleHiSectionLabel = (e) => {
    const sectionLabel = e.target.value

    this.setState({ label_Hi: sectionLabel })
  }
  updateLabels = async () => {
    const { itemToEdit, label_En, label_Hi, label_Te } = this.state
    // const input = {
    //   PK: itemToEdit.PK,
    //   SK: itemToEdit.SK,
    //   sectionLabel_Te: label_Te,
    //   sectionLabel_En: label_En,
    //   sectionLabel_Hi: label_Hi,
    // }
    // const data = await UpdateSectionDetails(input)
    // // if (data.statusCode == 'A276') {
    this.setState({ showModal: false })
    this.props.UpdateSectionDetails(itemToEdit.SK, label_Hi, label_Te, label_En)
    // }
  }
  showConfirmationModal = (item, renderingItem, type, itemIndex) => {
    const removeItemDetails = {
      item,
      renderingItem,
      type,
      itemIndex,
    }
    this.setState({
      confirmationModal: true,
      removeItemDetails,
    })
  }
  removeItemfromSection = async () => {
    const { item, renderingItem, itemIndex } = this.state.removeItemDetails
    const sectionDetails = this.state.sectionDetails
    const findIndex = sectionDetails[itemIndex].sectionDetails.findIndex(
      (section) => section.SK == item.SK
    )
    sectionDetails[itemIndex].sectionDetails.splice(findIndex, 1)
    const ids = sectionDetails[itemIndex].sectionDetails.map((item) => item.SK)
    const input = {
      PK: renderingItem.PK,
      SK: renderingItem.SK,
    }
    if (renderingItem.GSIRecordType == 'peopleSectionPages') {
      input.people = ids
    } else if (renderingItem.GSIRecordType == 'peopleSectionPeople') {
      input.addedPeople = ids
    } else if (renderingItem.GSIRecordType == 'pageSectionPeople') {
      input.pages = ids
    } else if (renderingItem.GSIRecordType == 'pageSectionPages') {
      input.addedPages = ids
    }
    // const data = await UpdateSection(input)
    // if (data.statusCode == 'A292') {
    //   this.setState({ remeasure: Date.now().toString(), sectionDetails: sectionDetails })
    //   this.props.UpdateSections(sectionDetails)
    // }
  }
  renderItem = (item, index) => {
    const itemName = item.PK + 'Name'
    let name = item[itemName]
    // if (item.SK.includes('section#')) {
    //   type = item.GSIRecordType == 'pageSectionPages' ? 'page' : 'people'
    // }
    // const itemIndex = index
    // const labelValue =
    //   item.sectionLabel_En != null
    //     ? item.sectionLabel_En
    //     : item.sectionLabel_Te != null
    //     ? item.sectionLabel_Te
    //     : item.sectionLabel_Hi
    return (
      // <div onLongPress={drag}>
      <div>
        <div
          class='actionIcons row'
          style={{ right: '0px', position: 'absolute', cursor: 'default' }}
        >
          <div
            class='column'
            style={{ width: '50px' }}
            onClick={() => {
              this.setState({
                modalVisible: true,
                itemTodelete: item,
              })
            }}
          >
            <i class='fas fa-trash' />
          </div>
        </div>
        <div style={{ marginBottom: '35px' }}>
          <div>
            <div>
              <text>{`Type: ${item.PK}`}</text>
            </div>
            <div>
              <text>{`Name: ${name}`}</text>
            </div>
          </div>
        </div>
      </div>
    )
  }
  // myCallback = this.renderItem.bind(this)
  keyExtractor = (item) => {
    return `draggable-item-${item.SK}-${item.sectionPosition}`
  }
  updateSortorder = (data) => {
    this.setState({ sectionDetails: data })
    this.props.updateSortedOrder(data)
  }
  handleDrag = (ev) => {
    this.setState({ dragId: ev.currentTarget.id })
  }

  handleDrop = (ev) => {
    const { sectionDetails, dragId } = this.state
    const dragItem = sectionDetails.find((item) => item.SK === dragId)
    const dropItem = sectionDetails.find((item) => item.SK === ev.currentTarget.id)
    const dragIndex = sectionDetails.findIndex((section) => section.SK == dragId)
    const dropIndex = sectionDetails.findIndex((section) => section.SK == ev.currentTarget.id)
    sectionDetails[dropIndex] = dragItem
    sectionDetails[dragIndex] = dropItem
    this.setState({ sectionDetails: sectionDetails }, () => {
      this.props.updateSortedOrder(this.state.sectionDetails)
    })
  }

  render() {
    return (
      <div>
        <div className='sectionsItemsContainer'>
          {this.state.sectionDetails &&
            this.state.sectionDetails.map((item, index) => (
              <div
                class='col-md-5 sectionItems'
                draggable={true}
                id={item.SK}
                onDragOver={(ev) => ev.preventDefault()}
                onDragStart={this.handleDrag}
                onDrop={this.handleDrop}
                style={{
                  border: '1px solid',
                  borderColor: '#999999',
                  marginBottom: '5px',
                  cursor: 'grab',
                }}
              >
                {this.renderItem(item, index)}
              </div>
            ))}
        </div>
        <div style={{ flex: 1 }}>
          <Modal
            show={this.state.modalVisible}
            onHide={() => this.setState({ modalVisible: false })}
          >
            <Modal.Body>Are You Sure You Want To Remove This Section ?</Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.setState({ modalVisible: false })}>Cancel</Button>
              <Button onClick={() => this.deleteSectionFromPage()}>Delete</Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={this.state.confirmationModal}
            onHide={() => this.setState({ confirmationModal: false })}
          >
            <Modal.Body>Are You Sure You Want To Remove Item From This Section ?</Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.setState({ confirmationModal: false })}>Cancel</Button>
              <Button onClick={() => this.removeItemfromSection()}>Delete</Button>
            </Modal.Footer>
          </Modal>

          <Modal show={this.state.showModal} onHide={() => this.setState({ showModal: false })}>
            <Modal.Header>
              <label>Update Section Labels</label>
            </Modal.Header>

            <Modal.Body>
              <div style={{ marginBottom: '5px' }}>
                <text>{'En Label '}</text>
                <div>
                  <input
                    type='text'
                    onChange={(value) => {
                      this.handleEnSectionLabel(value)
                    }}
                    value={this.state.label_En}
                    placeholder='En Label Placeholder'
                  ></input>
                </div>
              </div>
              <div style={{ marginBottom: '5px' }}>
                <text>{'Te Label '}</text>
                <div>
                  <input
                    type='text'
                    onChange={(value) => {
                      this.handleTeSectionLabel(value)
                    }}
                    value={this.state.label_Te}
                    placeholder='Te Label PlaceHolder'
                  ></input>
                </div>
              </div>
              <div style={{ marginBottom: '5px' }}>
                <text>{'Hi Label'}</text>
                <div>
                  <input
                    type='text'
                    onChange={(value) => {
                      this.handleHiSectionLabel(value)
                    }}
                    value={this.state.label_Hi}
                    placeholder='Hi Label PlaceHolder'
                  ></input>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.setState({ showModal: false })}>Cancel</Button>
              <Button onClick={() => this.updateLabels()}>Update</Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    )
  }
}
export default DraggableTemplateSections
